import React from "react";
import Landing from "../Blocks/Landing.Slide";
import Services from "../Blocks/Services.Slide";
import AboutUs from "../Blocks/AboutUs";
import FooterQuote from "../Components/FooterQuote/FooterQuote";
import VideoCarousel from "../Components/VideoCarousel/VideoCarousel";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

export default function MainPage() {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const schemaOrgWebsite = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "ontheweb.agency",
    "url": "https://ontheweb.agency/",
    "description": "Web Design, Development & Digital Marketing Solutions That Put You Ahead of the Competition",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://ontheweb.agency/search?q={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  };

  const schemaOrgOrganization = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "ontheweb.agency",
    "url": "https://ontheweb.agency/",
    "logo": "https://ontheweb.agency/logo.png",
    "sameAs": [
      "https://www.twitter.com/onthewebagency",
      "https://github.com/MatanDessaur",
      "https://www.linkedin.com/in/matandessaur"
    ]
  };

  return (
    <>
      <Helmet>
        <html lang={currentLang} />
        <title>OnTheWeb Agency | Custom Website Design & Development</title>
        <meta name="description" content="Your business, on the web. ontheweb crafts tailored websites that bring your unique business ideas to life with stunning design and powerful functionality." />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=5" />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="ontheweb.agency" />
        <meta name="keywords" content="web design, web development, tailored websites, custom web applications, responsive design, online presence" />

        <meta property="og:title" content="OnTheWeb Agency | Custom Website Design & Development" />
        <meta property="og:description" content="Your business, on the web. ontheweb crafts tailored websites that bring your unique business ideas to life with stunning design and powerful functionality." />
        <meta property="og:url" content="https://ontheweb.agency/" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://ontheweb.agency/share-image.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="900" />
        <meta property="og:image:type" content="image/jpeg" />
        <meta property="og:image:alt" content="ontheweb.agency - Tailored Web Design and Development Solutions" />
        <meta property="og:site_name" content="ontheweb.agency" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@onthewebagency" />
        <meta name="twitter:title" content="OnTheWeb Agency | Custom Website Design & Development" />
        <meta name="twitter:description" content="Your business, on the web. ontheweb crafts tailored websites that bring your unique business ideas to life with stunning design and powerful functionality." />
        <meta name="twitter:image" content="https://ontheweb.agency/share-image.jpg" />

        {/* Single canonical URL - site uses browser detection for language */}
        <link rel="canonical" href="https://ontheweb.agency/" />
        
        <script type="application/ld+json">
          {JSON.stringify(schemaOrgWebsite)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(schemaOrgOrganization)}
        </script>
      </Helmet>
      <Landing />
      <Services />
      <VideoCarousel />
      <AboutUs />
      <FooterQuote />
    </>
  );
}